import { Tooltip } from "@mui/material";

import { StatusChip, StatusChipColor } from "./StatusChip";

type IssueCountProps = {
  issueCount?: number | null;
  ignoreForReport?: boolean;
  onClick?: () => void;
  /**
   * Design-system role for the chip. Defaults to `error` (the actionable-issue
   * red). `ignoreForReport` always overrides this to the neutral grey `default`.
   */
  color?: StatusChipColor;
};

export const IssueCount = ({
  issueCount,
  ignoreForReport,
  onClick,
  color = "error",
}: IssueCountProps) => {
  if (!issueCount) return null;

  const chip = (
    <StatusChip
      label={issueCount}
      color={ignoreForReport ? "default" : color}
      onClick={
        onClick
          ? (e) => {
              // Only stop propagation when this chip has its own handler.
              // Otherwise let the click bubble so the enclosing row's
              // onRowClick (typical pattern: open editor) still fires.
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
    />
  );

  return ignoreForReport ? (
    <Tooltip title="You are not required to fix these issues because this chemical will not be reported">
      {chip}
    </Tooltip>
  ) : (
    chip
  );
};
